import { useState } from 'react';
import { ButtonMain, Card } from '@quero-delivery/quero-components-web';

import Tooltip from 'rc-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import styles from './Dashboard.module.scss';

import Map from './MotoboysMap';
import JsonView from '@/Shared/JsonView';
import { image } from '@/Themes/Images';
import { useAppSelector } from '@/_store/hooks';
import { ModalListActiveDeliverymen } from '@/_features/deliveries/componentes/modal-list-active-deliverymen';
import PurpleButton from '@/Components/shared/purple-button/PurpleButton';
import { useGetDashboardInfos } from '@/_features/dashboard/api/get-dashboard-infos';
import { PlacesInfosDashboardModal } from '@/_features/dashboard/components/places-infos-dashboard-modal';
import {
  ENUM_LEGEND_STATUS,
  LEGEND_STATUS_OPTIONS,
} from '@/_features/dashboard/constants';
import CitiesSelection from '@/Components/CitiesSelection/CitiesSelection';
import { DeliveryModelSelection } from '@/_features/dashboard/components/delivery-model-selection/delivery-model-selection';
import { useDashboardAggregateData } from '@/_features/dashboard/hook/use-dashboard-aggregate-data';
import { Skeleton } from '@/_config/lib/react-native-skeleton';
import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';

// TODO: refactor this component with the new structure
function Dashboard() {
  const selectedCityOnDashboard = useAppSelector(
    state => state.filters.cityIdOnDashboard,
  );

  const [showMotoboysList, setShowMotoboysList] = useState(false);
  const [showPlaceList, setShowPlaceList] = useState(false);
  const [filters, setFilters] = useState<string[]>([]);

  const { data, isLoading } = useGetDashboardInfos(
    {
      cityId: selectedCityOnDashboard || '',
    },
    {
      enabled: !!selectedCityOnDashboard,
    },
  );

  const {
    deliverymenInfo,
    onlineDeliverymen,
    placesInfos,
    placesWithLocation,
  } = data || {};

  const { deliverymanData, placeData } = useDashboardAggregateData({
    deliverymenInfo,
    placesInfos,
  });

  const hasMotoboyOnline = onlineDeliverymen && onlineDeliverymen.length > 0;

  const deliverymanTotal = deliverymanData.total;
  const deliverymanOnline = deliverymanData.online;
  const deliverymanAvailable = deliverymanData.available;
  const deliverymanInDelivery = deliverymanData.inDelivery;
  const deliverymanOffline = deliverymanData.offline;

  const placesTotal = placeData.total;
  const placesOpen = placeData.open;
  const placesClosed = placeData.closed;
  const placesWithPendingDeliveries =
    placeData.totalPlacesWithPendingDeliveries;
  const placesWithInProgressDeliveries =
    placeData.totalPlacesWithInProgressDeliveries;
  const placesInProgressOrders = placeData.totalInProgressOrders;
  const { totalPlacesWithInProgressOrders } = placeData;

  return (
    <div className="container">
      <div className={styles.containerBoxes}>
        <div className={styles.citiesSelection}>
          <div className={styles.filterContainer}>
            <CitiesSelection />
          </div>
          <div className={styles.filterContainer}>
            <DeliveryModelSelection />
          </div>
        </div>
        <div className={styles.containerGrid}>
          <div>
            <strong className="subtitle1">Entregadores</strong>

            {isLoading ? (
              <Skeleton
                borderRadius={8}
                height={81}
                className={styles.cardInfo}
              />
            ) : (
              <Card
                type="min-shadow"
                className={styles.cardInfo}
                loading={isLoading}
              >
                <div className={styles.infoDeliverymanContainer}>
                  <div>
                    <p>{deliverymanTotal}</p>
                    <span>
                      Total de entregador
                      {deliverymanTotal > 1 ? 'es ' : ' '}
                      <Tooltip overlay="Entregadores online nos últimos 45 dias">
                        <FontAwesomeIcon icon={faQuestionCircle} />
                      </Tooltip>
                    </span>
                  </div>
                  <div>
                    <p>{deliverymanOnline}</p>
                    <span>Online</span>
                  </div>
                  <div>
                    <p>{deliverymanAvailable}</p>
                    <span>
                      {deliverymanAvailable > 1 ? 'Disponíveis' : 'Disponível'}
                    </span>
                  </div>
                  <div>
                    <p>{deliverymanInDelivery}</p>
                    <span>Em entrega</span>
                  </div>
                  <div>
                    <p>{deliverymanOffline}</p>
                    <span>Offline</span>
                  </div>
                </div>
              </Card>
            )}
          </div>

          {isLoading ? (
            <Skeleton
              borderRadius={8}
              height={40}
              className={styles.containerButtons}
            />
          ) : (
            <div className={styles.containerButtons}>
              {hasMotoboyOnline && (
                <PurpleButton
                  textFirst="Entregadores online"
                  width="100%"
                  onClick={() => setShowMotoboysList(true)}
                />
              )}
              <ButtonMain
                textFirst="Estabelecimentos"
                width="100%"
                secondary
                disabled={isLoading}
                onClick={() => setShowPlaceList(true)}
              />
            </div>
          )}

          <div className={styles.generalContainer}>
            <strong className="subtitle1">Estabelecimentos</strong>
            <div className={styles.placeContainer}>
              {isLoading ? (
                <>
                  <div className={styles.skeletonsContainer}>
                    <Skeleton borderRadius={8} height={120} />
                  </div>
                  <div className={styles.skeletonsContainer}>
                    <Skeleton borderRadius={8} height={120} />
                  </div>
                </>
              ) : (
                <>
                  <Card
                    type="min-shadow"
                    className={styles.cardInfo}
                    loading={isLoading}
                  >
                    <div className={styles.infoPlacesContainer}>
                      <div>
                        <div className={styles.allPlaces}>
                          <p>{placesTotal}</p>
                          <span>
                            Todas as lojas{' '}
                            <Tooltip overlay="Estabelecimentos ativos nos últimos 45 dias">
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Tooltip>
                          </span>
                        </div>
                      </div>

                      <table>
                        <tr>
                          <td>{placesOpen}</td>
                          <td>Abertas</td>
                        </tr>

                        <tr>
                          <td>{placesClosed}</td>
                          <td>Fechadas</td>
                        </tr>

                        <tr>
                          <td>{placesWithPendingDeliveries}</td>
                          <td>Com entrega pendente</td>
                        </tr>

                        <tr>
                          <td>{placesWithInProgressDeliveries}</td>
                          <td>Com entrega em andamento</td>
                        </tr>
                      </table>
                    </div>
                  </Card>
                  <Card
                    type="min-shadow"
                    className={styles.cardInfo}
                    loading={isLoading}
                  >
                    <div className={styles.infoOrdersContainer}>
                      <div>
                        <p>{placesInProgressOrders}</p>
                        <span>Pedidos em andamento</span>
                      </div>
                      <div>
                        <p>{totalPlacesWithInProgressOrders}</p>
                        <span>Lojas com pedidos em andamento</span>
                      </div>
                    </div>
                  </Card>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={styles.containerLegend}>
          <div>
            <strong className="subtitle1">Legenda</strong>
            <Card type="min-shadow" className={styles.cardLegend}>
              <div className={styles.cardLegendInfo}>
                <div>
                  <img src={image.marker_place} alt="entrega_em_andamento" />
                  <label>
                    {ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_IN_PROGRESS}
                  </label>
                </div>
                <div>
                  <img
                    src={image.marker_place_pending_order}
                    alt="pedido_pendente"
                  />
                  <label>
                    {ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_PENDING}
                  </label>
                </div>
                <div>
                  <img src={image.marker_disponivel} alt="disponivel" />
                  <label>{ENUM_LEGEND_STATUS.DELIVERYMAN_AVAILABLE}</label>
                </div>
                <div>
                  <img src={image.marker_entregando} alt="entregando" />
                  <label>{ENUM_LEGEND_STATUS.DELIVERYMAN_IN_DELIVERY}</label>
                </div>
                <div>
                  <img
                    src={image.marker_indo_estabelecimento}
                    alt="dirigindo-se_a_loja"
                  />
                  <label>{ENUM_LEGEND_STATUS.DELIVERYMAN_GOING_TO_STORE}</label>
                </div>
              </div>
            </Card>
          </div>
          <div className={styles.filterContainer}>
            <DropdownInput
              label="Filtros"
              labelClassName={styles.spanSelect}
              className={styles.select}
              options={LEGEND_STATUS_OPTIONS}
              value={filters || []}
              search
              multiple
              placeholder="Filtrar por status"
              onChange={value => {
                const newStatus = value as string[];

                setFilters(newStatus);
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles.mapContainer}>
        <Card type="shadow" style={{ height: '85vh' }}>
          <Map {...{ filters }} />
        </Card>
      </div>

      <footer className="end-page-margin" />

      <JsonView name="Entregadores" source={onlineDeliverymen} />
      <JsonView name="Places" source={placesWithLocation} />

      <ModalListActiveDeliverymen
        open={
          showMotoboysList &&
          !!onlineDeliverymen &&
          onlineDeliverymen?.length > 0
        }
        onClose={setShowMotoboysList}
        onlineDeliverymen={onlineDeliverymen || []}
      />

      <PlacesInfosDashboardModal
        open={showPlaceList}
        onClose={setShowPlaceList}
      />
    </div>
  );
}

export default Dashboard;
